import { Button } from "@/components/ui/button";
import { exportFundList } from "@/utils/fundDataExport";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Spinner } from "@/components/ui/Spinner";

export const ExportFundData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const data = await exportFundList();
      if (!data) {
        toast({
          title: "Export Failed",
          description: "Could not export fund data",
          variant: "destructive"
        });
        return;
      }

      // Create downloadable files
      const promptBlob = new Blob([data.researchPrompt], { type: 'text/plain' });
      const promptUrl = URL.createObjectURL(promptBlob);
      const promptLink = document.createElement('a');
      promptLink.href = promptUrl;
      promptLink.download = 'fund-research-prompt.txt';
      promptLink.click();

      const jsonBlob = new Blob([JSON.stringify(data.funds, null, 2)], { type: 'application/json' });
      const jsonUrl = URL.createObjectURL(jsonBlob);
      const jsonLink = document.createElement('a');
      jsonLink.href = jsonUrl;
      jsonLink.download = 'fund-data-template.json';
      jsonLink.click();

      toast({
        title: "Export Successful",
        description: "Fund data and research prompt have been downloaded",
      });
    } catch (error) {
      console.error('Export error:', error);
      toast({
        title: "Export Failed",
        description: "An error occurred while exporting fund data",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button 
      onClick={handleExport} 
      disabled={isLoading}
      className="w-full md:w-auto"
    >
      {isLoading ? (
        <>
          <Spinner size="sm" className="mr-2" ariaLabel="Exporting" />
          Exporting...
        </>
      ) : (
        'Export Fund Data for Research'
      )}
    </Button>
  );
};